import { Box, Loader } from "@dbn/omnichannel-design-system-g4p";
import { useEffect } from "react";

interface Props {
  onReload: () => unknown;
}

export const ReloadSuspense = (props: Props) => {
  useEffect(() => {
    props.onReload();
  }, []);

  return (
    <Box hAlignContent="center">
      <Loader />
    </Box>
  );
};
